import { parseLocalDateString } from '@/lib/utils/dateValidation'

/** Local calendar Date for DatePicker `minDate`, or undefined if unset/invalid. */
export function toDatePickerMinDate(isoDate: string | undefined | null): Date | undefined {
  if (!isoDate) return undefined
  return parseLocalDateString(isoDate) ?? undefined
}

/** True when both dates are set and end is strictly before start (YYYY-MM-DD). */
export function isEndDateBeforeStart(
  startIso: string | undefined | null,
  endIso: string | undefined | null,
): boolean {
  if (!startIso || !endIso) return false
  return endIso < startIso
}
